import { useWindowDimensions } from '../';

export const useCalculateTableRows = (
  rowHeight: number,
  minRows: number,
  pageSpaceExcludingRows: number,
) => {
  const { height } = useWindowDimensions();

  const tableSpace = height - pageSpaceExcludingRows;
  const newRows = Math.floor(tableSpace / rowHeight) - 1; // -1 for the header

  return { rows: newRows > minRows ? newRows : minRows };
};
